import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { FormControl, Validators } from '@angular/forms';
import { DtoSector } from '../../../models/sector.model';
import { SectorService } from '../sector.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-edit-sector',
  templateUrl: './edit-sector.component.html'
})
export class EditSectorComponent implements OnInit {

  sectorName = new FormControl('', [
    Validators.required,
    Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
  ])
  
  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<EditSectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DtoSector,
    private sectorService: SectorService,
    private toasterService: ToastrService ) {}
 
  ngOnInit(): void {
    if(this.data.sectorId){
      this.sectorName.setValue(this.data.sectorName);
    }
  }

  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }

  updateSector(){
    let payload: DtoSector = {
      sectorId : this.data.sectorId,
      sectorName: this.sectorName.value
    } as DtoSector
    this.sectorService.updateSector(payload).subscribe((response: any)=>{
      if(response){
        this.toasterService.success('Sector updated successfully', 'Success');
        this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

}
